// src/utils/sanitizeInput.ts

/**
 * Recursively sanitize all string properties in an object or array.
 * Trims whitespace and strips dangerous HTML tags.
 */
import DOMPurify from 'dompurify';

export function sanitizeInput<T>(input: T): T {
	if (typeof input === 'string') {
		// Remove dangerous HTML and trim
		return DOMPurify.sanitize(input, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] }).trim() as any;
	}
	if (Array.isArray(input)) {
		return input.map(sanitizeInput) as any;
	}
	if (typeof input === 'object' && input !== null) {
		const sanitized: any = {};
		for (const key in input) {
			sanitized[key] = sanitizeInput((input as any)[key]);
		}
		return sanitized;
	}
	return input;
}
